import { render } from "./PaymentResult.vue?vue&type=template&id=7b024164&scoped=true&ts=true"
import script from "./PaymentResult.vue?vue&type=script&lang=ts"
export * from "./PaymentResult.vue?vue&type=script&lang=ts"

import "./PaymentResult.vue?vue&type=style&index=0&id=7b024164&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b024164"]])

export default __exports__